import {Link, useLocation} from 'react-router-dom'
import {matchPath} from 'react-router'
import {ButtonGroup, Button, Box} from '@mui/material'
import {grey} from '@mui/material/colors'
import DashboardIcon from '@mui/icons-material/Dashboard'
import FolderIcon from '@mui/icons-material/Folder'
import {ReactNode, useMemo} from 'react'

export const NavigationTabs = () => {
  const location = useLocation()

  const tabs = useMemo((): Tab[] => {
    const tabs: Tab[] = [
      {
        to: '/dashboard',
        label: 'Dashboard',
        icon: <DashboardIcon />,
      },
      {
        to: '/submissions',
        label: 'Submissions',
        icon: <FolderIcon />,
      },
    ]

    return tabs
  }, [])

  return (
    <ButtonGroup color='primary' aria-label='Page'>
      {tabs.map((tab) => {
        const match = matchPath(
          {
            path: tab.to,
            end: false,
          },
          location.pathname
        )
        return (
          <Button
            id={`nav-bar-link-${tab.label.split(' ').join('-').toLocaleLowerCase()}`}
            component={Link}
            to={tab.to}
            key={tab.to}
            variant={match ? 'contained' : 'outlined'}
            sx={(theme) => ({
              border: match ? `1px solid ${theme.palette.primary.main}` : `1px solid ${grey[50]}`,
              color: match ? undefined : grey[500],
              backgroundColor: match ? undefined : grey[50],
              borderRadius: 0,
              display: 'inline-flex',
              alignItems: 'center',
              '&:first-of-type': {
                borderTopLeftRadius: theme.shape.borderRadius,
                borderBottomLeftRadius: theme.shape.borderRadius,
              },
              '&:last-of-type': {
                borderTopRightRadius: theme.shape.borderRadius,
                borderBottomRightRadius: theme.shape.borderRadius,
              },
            })}
          >
            <Box
              component='span'
              sx={(theme) => ({mr: theme.spacing(1), display: 'inline-flex', alignItems: 'center'})}
            >
              {tab.icon}
            </Box>
            {tab.label}
          </Button>
        )
      })}
    </ButtonGroup>
  )
}

interface Tab {
  to: string
  label: string
  icon: ReactNode
}
